module.exports = __webpack_public_path__ + "img/KeyMetrics.15028224.png";